import * as Immutable from 'immutable';
import ModuleListStore from '../../ModuleList/_stores/ModuleListStore';

export interface ILayerStore {
	id: string
	name: string
	modules: Immutable.OrderedSet<string>
	visible: boolean
}

const defaultStore = Immutable.Record<ILayerStore>({
	id: '',
	name: undefined,
	modules: Immutable.OrderedSet<string>(),
	visible: true
});

export default class LayerStore extends defaultStore implements ILayerStore {}